import React, { Component } from "react"
import { BrowserRouter, Route } from "react-router-dom"
import loadable from "loadable-components"
import "./App.css"

const ROUTER_BASE = process.env.REACT_APP_ROUTER_BASE || "/"
const Settings = loadable(() => import("./pages/Settings/Settings"))
const Dashboard = loadable(() => import("./pages/Dashboard/Dashboard"))
class App extends Component {
  render() {
    return (
      <BrowserRouter basename={ROUTER_BASE}>
        <div className="app">
          <Route
            path="/remote"
            exact
            render={(props) => (
              <Settings
                {...props}
              />
            )}
          />
          <Route
            path="/settings"
            exact
            render={(props) => (
              <Settings
                {...props}
              />
            )}
          />
          <Route
            path="/dashboard"
            exact
            render={(props) => (
              <Dashboard
                {...props}
              />
            )}
          />
        </div>
      </BrowserRouter>
    )
  }
}

export default App
